import { Loader, Select } from "@mantine/core"
import React from "react"
import { useActions, useAppState } from "src/state"
import { User_Type_Enum } from "src/state/gql/_types"
import { GenericFieldProps } from "src/utils/forms"
import { capitalizeWords } from "src/utils/string"

export const OperationsAdminTalentSelect: React.FC<GenericFieldProps> = ({ id, name, label, onChange, onBlur, value, error, required, description, disabled, classNames }) => {

    const { itemsList, loading } = useAppState(state => state.users)
    const  getAllItems = useActions().users.getAllItems
    const { tenant_id: currentTenantId } = useAppState(state => state.auth)

    React.useEffect(() => {

        let controller: AbortController | null = new AbortController();

        const loadItems = async () => {

            if (controller) {
                try {
                    await getAllItems({
                        where: { 
                            type: {
                                _eq: User_Type_Enum.Talent
                            },
                            tenant_id: {
                                _eq: currentTenantId
                            }
                        }
                    })
                    controller = null;
                } catch (e: any) {
                    if (e.name !== 'AbortError') {
                        console.error(e)
                    }
                }
            }

        }
        
        loadItems()

        return () => controller?.abort()

    }, [])

    if (!!!itemsList.length) error = 'No Active Talent'
    
    return (
        <Select
            label={label}
            id={id}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            error={error}
            required={required}
            disabled={disabled}
            description={description}
            rightSection={loading ? <Loader size="xs" /> : null}
            placeholder="Select Talent..."
            searchable
            clearable
            data={itemsList.map(i=>({
                label: capitalizeWords(`${i.first_name} ${i.last_name} ${!!i.alias?`(${i.alias})`:''}`),
                value: i.id
            }))}
            autoComplete="off"
            classNames={classNames}
        />
    )

}